import { Component, OnInit } from '@angular/core';
import {NavController,AlertController,ToastController,IonRouterOutlet} from '@ionic/angular';
import { GlobalVars } from '../../../../providers/globalVars';
import * as firebase from 'firebase/app';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { msgfunc } from '../../../../providers/msgfunc';
@Component({
  selector: 'app-pitemcheckout',
  templateUrl: './pitemcheckout.page.html',
  styleUrls: ['./pitemcheckout.page.scss'],
})
export class PitemcheckoutPage implements OnInit {

  enoughPnt = false; //포인트 충분한가?
  pitemid:any;
  tagVal:any;
  groupVal:any;
  titVal:any;
  images:any;
  imagethumbs:any;
  desc:any;
  itemPrice:any;
  limit:any;
  eventend:any;
  editable:boolean = false;
  posterId:any;
  sold:any;
  once:any;
  appitem:any;
  type:any;
  adbanner:any;
  exist:any = 'notset';
  alarmlist:any = [];
  constructor(public navCtrl:NavController,public gv: GlobalVars,private msgfunc:msgfunc,private alertCtrl:AlertController,
    private translate: TranslateService, private route: ActivatedRoute, private router:Router,
     public outlet: IonRouterOutlet, private toastCtrl: ToastController) { }

  ngOnInit() {
    this.pitemid = this.route.snapshot.paramMap.get('id');
  }

  getdata(){
    if(this.pitemid)
    {
      firebase.database().ref('/pmall/' + this.pitemid).once('value').then(rst=>{
        let data = rst.val();
        if(data)
        {
          this.tagVal = data.tag;
          this.groupVal = data.shortinfo;
          this.titVal = data.title;
          this.images = data.images;
          this.imagethumbs = data.imagethumb;
          this.desc = data.desc;
          this.itemPrice = this.gv.advtotalpoint?this.gv.advtotalpoint:data.point;
          this.gv.advtotalpoint = 0;
          this.limit = data.limit;
          this.sold = data.sold;
          this.once = data.once;
          this.eventend = new Date(data.eventend);
          this.posterId = data.userId;
          this.appitem = data.appitem;
          this.type = data.type;
          this.adbanner = data.adbanner;
          this.alarmlist = [];
          if(data.alarmuser)
          {
            Object.keys(data.alarmuser).forEach(a=>{
              this.alarmlist.push({uid:data.alarmuser[a].uid});
            })
          }
          //advbanner 일때 

          if(data.userId == this.gv.uid || this.gv.admin)
            this.editable = true;
        }
        if(this.once)
        {
          firebase.database().ref('/userData/' + this.gv.uid + '/pointitem').orderByChild('pitemid').
          equalTo(this.pitemid).once('value').then(item=>{
            if(item.val())
              this.exist = item.val().createdDate;
            else
              this.exist = 'ok';
          })
        }
        else
          this.exist = 'ok';
      })
    }
  }

  ionViewWillEnter()
  {
    this.getdata();
    firebase.database().ref('/userProfile/' + this.gv.uid + '/totalcount').once('value').then(total=>{
      this.gv.utotal = total.val();
      this.calcpoint(this.gv.utotal.point);
    })
  }

  back(){
    if(this.outlet && this.outlet.canGoBack())
      { 
        //console.log('아울렛팝!')
        this.outlet.pop()}
    else
      {
      //console.log('네비팝!')
      this.navCtrl.back();
      //this.router.navigate(['/tabs/pm']);
      }
  }

  calcpoint(mp) {
    if( mp - this.itemPrice  >= 0) {
      this.enoughPnt = true;
    } else {
      this.enoughPnt = false;
    }
  }
  negativePnt(mp){
    if(Math.sign(mp) <= -1) {
      return true;
    }
  }
  checkout(){
    if(this.enoughPnt && this.exist == 'ok')
    {
    // 사용기한 있을때 또는 사용기한 얼마남지 않았을때 확인알림 - 사용가능기한이 8일밖에 남지 않았습니다. 그래도 구매하시겠습니까? - 표시해줄 필요 있음..!
    firebase.database().ref('/pmall/' + this.pitemid).once('value').then(rst=>{
      if(rst.val().limit && rst.val().limit <= rst.val().sold)
      {
        //모두 판매완료됨..
        this.alertCtrl.create({
        message:'죄송합니다. 방금 마지막 상품이 판매되었습니다.', buttons:["확인"]}).then(_=>_.present())
      }
      else{
        if(this.once)
        {
          firebase.database().ref('/userData/' + this.gv.uid + '/pointitem').orderByChild('pitemid').
          equalTo(this.pitemid).once('value').then(item=>{
            if(item.val())
              this.exist = item.val().createdDate;
            else
              this.exist = 'ok';
            if(this.exist=='ok')
            {
            firebase.database().ref('/userProfile/' + this.gv.uid + '/totalcount').once('value').then(total=>{
            this.gv.utotal = total.val();
            this.calcpoint(this.gv.utotal.point);
            if(this.enoughPnt)
            {
              firebase.database().ref('/pmall/' + this.pitemid).update({sold:this.sold+1});
              firebase.database().ref('/userData/' + this.gv.uid + '/pointitem').push({
                pitemid:this.pitemid, point:this.itemPrice, createdDate:firebase.database.ServerValue.TIMESTAMP, 
                used:false, state:'waiting', order:0,
              }).then(add=>{
                var lvltxt;
                this.translate.get('Level'+this.gv.ulvl).subscribe(res=>{
                  lvltxt = res;
                })

                  firebase.database().ref('/pmalldata/' + this.pitemid + '/' + add.key).set({
                  uid:this.gv.uid, createdDate:firebase.database.ServerValue.TIMESTAMP, used:false, title:lvltxt
                  })
                
                  
                firebase.database().ref('/point/' + this.gv.uid)
              .push({pcode:'itempurchase', point:-this.itemPrice, itemid:add.key, createdDate:firebase.database.ServerValue.TIMESTAMP})
              .then(_=>{
                firebase.database().ref('/userData/' + this.gv.uid + '/pointitem/' + add.key).update({state:'done'});
                this.msgfunc.pitemsoldnoti(this.pitemid, 'pitem', '구매함]' + this.titVal, lvltxt + '님이 ' + this.titVal + ' 상품을 구매하셨습니다.', this.posterId);
                if(this.alarmlist)
                  {
                    this.alarmlist.forEach(arm=>{
                      this.msgfunc.pitemsoldnoti(this.pitemid, 'pitem', '구매함]' + this.titVal, lvltxt + '님이 ' + this.titVal + ' 상품을 구매하셨습니다.', arm.uid);
                    })
                  }
                this.router.navigate(['/tabs/pm/purchaseconfirm'])
              })
              })
            }
            else{this.presentToast('포인트가 부족합니다.');}
            })
            }
            else 
              {this.alertCtrl.create({
                message:'중복구매 불가한 상품입니다.', buttons:["확인"]}).then(_=>_.present())}
          })
        }
        else{
          firebase.database().ref('/userProfile/' + this.gv.uid + '/totalcount').once('value').then(total=>{
          this.gv.utotal = total.val();
          this.calcpoint(this.gv.utotal.point);
          if(this.enoughPnt)
          {
            firebase.database().ref('/pmall/' + this.pitemid).update({sold:this.sold+1});
            firebase.database().ref('/userData/' + this.gv.uid + '/pointitem').push({
              pitemid:this.pitemid, point:this.itemPrice, createdDate:firebase.database.ServerValue.TIMESTAMP, 
              used:false, state:'waiting', order:0,
            }).then(add=>{
              var lvltxt;
              this.translate.get('Level'+this.gv.ulvl).subscribe(res=>{
                lvltxt = res;
              })

                firebase.database().ref('/pmalldata/' + this.pitemid + '/' + add.key).set({
                uid:this.gv.uid, createdDate:firebase.database.ServerValue.TIMESTAMP, used:false, title:lvltxt
                })
              switch(this.appitem){
                case 'usernick' :{ 
                  firebase.database().ref('/userProfile/' + this.gv.uid + '/nicklimit').transaction(limit => {
                    return (limit || 0) + 1;
                  })
                  break;
                  }
                case 'chprivatecmt' : { 
                  firebase.database().ref('/category/' + this.gv.pm_selectedcatkey + '/options').update({privatecmt:true})
                  break;
                  }
                case 'chnotice' : { 
                  firebase.database().ref('/category/' + this.gv.pm_selectedcatkey + '/options').update({chnotice:true})
                  break;
                  }
                case 'chanonymouscmt' : { 
                  firebase.database().ref('/category/' + this.gv.pm_selectedcatkey + '/options').update({anonymouscmt:true})
                  break;
                  }
                case 'snsautopost'  : { 
                  firebase.database().ref('/func/feed').push({
                    category:this.gv.pm_selectedcatname,
                    chid:this.gv.pm_selectedcatkey,
                    communityname: this.gv.pm_selectedchname,
                    createdDate:firebase.database.ServerValue.TIMESTAMP,
                    endDate:new Date().getTime()+(1000*60*60*24*365),
                    refurl:this.gv.pm_linkurl,
                    url:0,
                    userId:this.gv.uid
                  });
                  break;
                  }
                default:break;
              }
              this.gv.pm_selectedchname = null;
              this.gv.pm_selectedcatkey = null;
              this.gv.pm_selectedcatname = null;
              this.gv.pm_linkurl = null;
              if(this.adbanner)
                {
                this.gv.bannertarget.forEach(ban=>{
                  firebase.database().ref('/adv/banner').push({
                    createdDate:firebase.database.ServerValue.TIMESTAMP,
                    prioritypoint:1000,
                    img:'-',
                    route:'/',
                    show:false,
                    target:ban,
                    uid:this.gv.uid
                  });
                });
                this.gv.bannertarget = null;
                }
                
              
              firebase.database().ref('/point/' + this.gv.uid)
              .push({pcode:'itempurchase', point:-this.itemPrice, itemid:add.key, createdDate:firebase.database.ServerValue.TIMESTAMP})
              .then(_=>{
              let state = 'done';
              let used = null;

              if(this.adbanner) {state = 'processing';
                this.presentToast('배너광고 상품이 접수되었습니다.');
                this.msgfunc.sendmsg('NjQizqLkBINRT9LF9oHjmMing403', this.gv.uid, 
`안녕하세요!
배너광고 상품이 접수되어 아래와 같이 안내드립니다.

- 배너광고에 올리실 이미지가 있으신경우 올려주세요.
없으시다면 채널팀 디자이너분이 작업해서 드립니다. 

- 배너광고에 들어갈 문구를 정해주세요.(자체제작하신 이미지가 있는 경우는 예외)

- 위가 제공되고 영업일 24시간 내로 작업됩니다.
신청자와 최종 확인이 완료되면 배너광고 접수가 완료됩니다.

혹시 이해 안되시거나 궁금하신점 있으시면 언제든지 알려주세요.`, '광고담당자');
              };
              if(this.appitem == 'snsautopost'){ state = 'processing';
                this.presentToast('소셜미디어 퍼오기 상품이 접수되었습니다.');
                this.msgfunc.sendmsg('NjQizqLkBINRT9LF9oHjmMing403', this.gv.uid, 
              `안녕하세요!
소셜미디어 자동퍼오기 상품이 접수되어 아래와 같이 안내드립니다.

- 주소 확인이 완료되고 이상이 없는 즉시 글이 자동업로드 됩니다.
작업이 완료되면 완료되었다는 메시지 드릴겁니다.

- 혹시 24시간 내로 완료되지 않는다면 재확인 요청 해주세요.`, '광고담당자');
              };
              if(this.appitem == 'usernick')
              {used=true; this.presentToast('닉네임 변경가능 횟수가 추가 되었습니다.');}
              if(this.appitem == 'chnotice')
              {used=true; this.presentToast('선택하신 채널에 공지 기능이 추가 되었습니다.');}
              if(this.appitem == 'chanonymouscmt')
              {used=true; this.presentToast('선택하신 채널에 익명댓글 기능이 추가 되었습니다.');}
              if(this.appitem == 'chprivatecmt')
              {used=true; this.presentToast('선택하신 채널에 비밀댓글 기능이 추가 되었습니다.');}
              
              firebase.database().ref('/userData/' + this.gv.uid + '/pointitem/' + add.key).update({state:state, used:used});
              this.msgfunc.pitemsoldnoti(this.pitemid, 'pitem', '구매함]' + this.titVal, lvltxt + '님이 ' + this.titVal + ' 상품을 구매하셨습니다.', this.posterId);
              this.router.navigate(['/tabs/pm/purchaseconfirm'])
            })
            })
          }
          else{this.presentToast('포인트가 부족합니다.');}
          })
        }
      }
    })
    }
    else
    {
      if(!this.enoughPnt)
        this.presentToast('소지하신 포인트가 부족합니다.')
      else if(this.exist != 'ok')
        this.presentToast('중복 구매가 불가한 상품입니다.')
    }
  }

    async presentToast(message: string) {
    let toast = await this.toastCtrl.create({
      message: message,
      position: 'bottom',
      duration: 2600
    });
    toast.present();
  }

}
